/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/** House outline (16×16). Color via `currentColor`. */
const HomeIcon = ({
  size = 16,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d="M2.75 7.25L8 3.25L13.25 7.25V12.75C13.25 13.0261 13.0261 13.25 12.75 13.25H10.25V9.75H5.75V13.25H3.25C2.97386 13.25 2.75 13.0261 2.75 12.75V7.25Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
  </svg>
);

HomeIcon.propTypes = iconPropTypes;

export default HomeIcon;
